import { Card, Box } from "@mui/material";

export default function HiringFunnel({ title, data }) {
    const SVG_WIDTH = 500;
    const CENTER_X = SVG_WIDTH / 2;

    const START_Y = 30;
    const STEP_HEIGHT = 76;

    const GEOMETRY = [
        { top: 455, bottom: 286 }, // Applications
        { top: 286, bottom: 136 }, // Resume Qualified
        { top: 136, bottom: 136 }, // Interviewed
        { top: 136, bottom: 110 }, // Offer Sent
        { top: 110, bottom: 110 }  // Hired (FIXED)
    ];

    return (
        <Card
            sx={{
                p: 1,
                borderRadius: "12px !important",
                background: "#fff",
                boxShadow: "0px 1px 12px rgba(0, 0, 0, 0.1)",
                position: "relative",
                overflow: "visible"
            }}
        >
            {/* Title Bar */}
            <Box
                sx={{
                    position: "absolute",
                    top: "-10px",
                    left: "12px",
                    right: "12px",
                    height: "36px",
                    background: "#115f9c",
                    borderRadius: "4px !important",
                    display: "flex",
                    alignItems: "center",
                    px: "12px",
                    color: "#fff",
                    fontSize: { xs: 12, sm: 12, md: 16 },
                    fontWeight: 200,
                    boxShadow:"0px 1px 16px rgba(128, 203, 255, 0.5)"
                }}
            >
                {title}
            </Box>

            {/* Funnel */}
            <Box
                sx={{
                    width: "100%",
                    height: 460,

                    overflowY: "hidden",
                }}
            >

                <Box
                    sx={{
                        minWidth: SVG_WIDTH, //  forces scroll when screen is smaller
                        display: "flex",
                        justifyContent: "center",
                        mt: 2
                    }}
                >
                    <svg width={SVG_WIDTH} height={420}>
                        {data.map((item, i) => {
                            const { top, bottom } = GEOMETRY[i];

                            const y1 = START_Y + i * STEP_HEIGHT;
                            const y2 = y1 + STEP_HEIGHT;

                            const points =
                                top === bottom
                                    ? `
                  ${CENTER_X - top / 2},${y1}
                  ${CENTER_X + top / 2},${y1}
                  ${CENTER_X + top / 2},${y2}
                  ${CENTER_X - top / 2},${y2}
                `
                                    : `
                  ${CENTER_X - top / 2},${y1}
                  ${CENTER_X + top / 2},${y1}
                  ${CENTER_X + bottom / 2},${y2}
                  ${CENTER_X - bottom / 2},${y2}
                `;

                            return (
                                <g key={item.label}>
                                    <polygon fill={item.color} points={points} />

                                    <text
                                        x={CENTER_X}
                                        y={y1 + STEP_HEIGHT / 2 - 6}
                                        textAnchor="middle"
                                        fontSize="22"
                                        fontWeight="700"
                                        fill="#fff"
                                    >
                                        {item.value.toLocaleString()}
                                    </text>

                                    <text
                                        x={CENTER_X}
                                        y={y1 + STEP_HEIGHT / 2 + 16}
                                        textAnchor="middle"
                                        fontSize="13"
                                        fill="rgba(255,255,255,0.9)"
                                    >
                                        {item.label}
                                    </text>
                                </g>
                            );
                        })}
                    </svg>
                </Box>

            </Box>
        </Card>
    );
}
